module.exports = __webpack_public_path__ + "static/media/400396_01.1d16e1fd.png";